import { useQuery } from "@tanstack/react-query";

import { readBudgetDocuments } from "../../services/budget";
import { TReadDocumentByIdResponse } from "../../services/budget/read-budget-documents";

type ReadBudgetDocumentParams = {
    budgetId: string;
};

export function useReadBudgetDocument({ budgetId }: ReadBudgetDocumentParams) {
    return useQuery<
        TReadDocumentByIdResponse,
        unknown,
        TReadDocumentByIdResponse
    >({
        enabled: true,
        queryKey: ["readCosts", budgetId],
        queryFn: () => readBudgetDocuments({ budgetId }),
        refetchOnMount: "always",
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        retry: false,
    });
}
